<template>
  <div class="homepage">
    <div class="container supporters" v-if="!!mainSupporters.length">
      <div class="images flex">
        <div class="img" v-for="s in mainSupporters">
          <a :href="s.sponsor_href" target="_blank" v-if="!!s.sponsor_href">
            <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" />
          </a>
          <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" v-else />
        </div>
      </div>
    </div>
    <div class="topContent">
      <div class="container">
        <div class="content">
          <wysiwyg 
            :title="topWysiwyg.title"
            :content="topWysiwyg.content"
            class="big"
            />
        </div>
      </div>
    </div>
    <div class="topText">
      <generic-big-text 
        :text="topText.text"
        :btn-text="''"
        :btn-icon="''"
        :btn-href="topText.btnHref"
        :btn-style="topText.btnStyle"
        :btn-target="topText.btnTarget"
        :image="topText.image"
        :bg-style="topText.bgStyle"
        :text-color="topText.textColor"></generic-big-text>
    </div>

    <div class="imageWidgetWrapper" v-if="!!imagesWidget.length">
      <gallery
        :conf="{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          wrapAround: imagesWidget.length > 2 ? true : false,
          cellAlign: 'left'
        }"
        :prev-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }"
        :next-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }">
        <div class="carousel-cell" v-for="image in imagesWidget">    
          <image-widget 
            :key="image.id"
            :title="image.title"
            :sub-title="image.subTitle"
            :img="image.img"
            :cta-href="image.ctaHref"
            :cta-text="image.ctaText"></image-widget>
        </div>
      </gallery>
    </div>

    
    <div class="sectionsWrapper">
      <div class="container">
        <h3 class="sectionsTitle" v-html="sectionsTitle"></h3>
        <div class="sections">
          <network-section
            v-for="(section, index) in sections"
            :id="section.id"
            :color="section.color"
            :image="section.image"
            :num="section.num"
            :text="section.text"
            :key="section.id"></network-section>
        </div>
      </div>
    </div>

    <div class="bigBtnWrapper" v-if="false">
      <big-btn
        :color="bigBtn.color"
        :btn-href="bigBtn.btnHref"
        :btn-text="bigBtn.btnText"></big-btn>
    </div>

    <div class="storiesWrapper" v-if="!!stories.length">
      <div class="container">
        <h3 class="sectionsTitle" v-html="storiesTitle"></h3>
      </div>
      <div class="stories">
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            setGallerySize: false,
            watchCss: true,
            wrapAround: stories.length > 3 ? true : false,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }"
          :next-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }">
          <div class="carousel-cell" v-for="story in stories">    
            <story-widget
              :key="story.id"
              :title="story.title"
              :story-href="story.storyHref"
              :img="story.img"
              :authors="story.authors"></story-widget>
          </div>
        </gallery>
      </div>
    </div>

    <div class="newsWrapper galleryWrapper" v-if="news.length > 0">
      <div class="container">
        <h3 class="sectionsTitle" v-html="newsTitle"></h3>
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            watchCss: true,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: news.length > 2 ? 'block' : 'none',
          }"
          :next-style="{
            display: news.length > 2 ? 'block' : 'none',
          }">
            <div class="carousel-cell" v-for="n in news">    
              <image-widget 
                :title="n.title"
                :sub-title="n.subtitle"
                :img="n.img"
                :cta-href="n.ctaHref"
                :cta-text="n.ctaText"
                :cta-target="n.ctaTarget"></image-widget>
            </div>
        </gallery>
      </div>
    </div>

    <div class="galleryWrapper d-lg-none" v-if="randomSliderWidgets.length > 0">
      <gallery
        :conf="{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          wrapAround: true,
          autoPlay: 4000,
          cellAlign: 'left'
        }"
        :prev-style="{
          display: randomSliderWidgets.length > 1 ? 'block' : 'none'
        }"
        :next-style="{
          display: randomSliderWidgets.length > 1 ? 'block' : 'none'
        }">
        <div class="carousel-cell" v-for="s in randomSliderWidgets">    
          <slider-widget :conf="s"></slider-widget>
        </div>
      </gallery>
    </div>

    <div class="galleryWrapper d-none d-lg-block" v-if="sliderWidgets.length > 0">
      <gallery
        :conf="{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          wrapAround: true,
          autoPlay: 4000,
          cellAlign: 'left'
        }"
        :prev-style="{
          display: sliderWidgets.length > 1 ? 'block' : 'none'
        }"
        :next-style="{
          display: sliderWidgets.length > 1 ? 'block' : 'none'
        }">
        <div class="carousel-cell" v-for="s in sliderWidgets">    
          <slider-widget :conf="s"></slider-widget>
        </div>
      </gallery>
    </div>


    <div class="partnersWrapper">
      <div class="container">
        <div class="row" v-if="owners.length > 0">
          <div class="owners">
            <h5 class="partnerTitle">
              Un progetto di:
            </h5>
            <div class="flex">
              <div v-for="s in owners">
                <a :href="s.sponsor_href" target="_blank" v-if="!!s.sponsor_href">
                  <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" />
                </a>
                <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" v-else />
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="supporterPartners.length > 0">
          <div class="supportersPartners">
            <h5 class="partnerTitle">
              Con il sostegno di:
            </h5>
            <div class="flex">
              <div v-for="s in supporterPartners">
                <a :href="s.sponsor_href" target="_blank" v-if="!!s.sponsor_href">
                  <img :src="s.sponsor_logo">
                </a>
                <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" v-else>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="collaborators" v-if="collaborators.length > 0">
            <h5 class="partnerTitle">
              Realizzato in collaborazione con:
            </h5>
            <div class="flex">
              <div v-for="s in collaborators">
                <a :href="s.sponsor_href" target="_blank" v-if="!!s.sponsor_href">
                  <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" >
                </a>
                <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" v-else>
              </div>
            </div>
          </div>

          <div class="artDirection" v-if="artDirection.length > 0">
            <h5 class="partnerTitle">
              Art Direction:
            </h5>
            
            <div class="flex">
              <div v-for="s in artDirection">
                <a :href="s.sponsor_href" target="_blank" v-if="!!s.sponsor_href">
                  <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" />
                </a>
                <img :class="imgClasses(s)" :src="s.sponsor_logo" :alt="s.name" v-else>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </div>

    <div class="bottomTextWrapper">
      <div class="container">
        <network-description
          :network-logo="networkDescription.networkLogo"
          :network-name="networkDescription.networkName"
          :btn-href="networkDescription.btnHref"
          :btn-text="networkDescription.btnText"
          :text="networkDescription.text"></network-description>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericBigText from './generic_big_text'
  import ImageWidget from './image_widget'
  import NetworkSection from './network_section'
  import BigBtn from './big_btn'
  import StoryWidget from './story_widget'
  import NetworkDescription from './network_description'
  import Gallery from './gallery'
  import Wysiwyg from './wysiwyg'
  import SliderWidget from './slider_widget'

  export default {
    name: 'Homepage',
    components:{
      GenericBigText,
      Wysiwyg,
      ImageWidget,
      NetworkSection,
      BigBtn,
      StoryWidget,
      NetworkDescription,
      Gallery,
      SliderWidget
    },

    data(){
      return {
      }
    },
    props: {
      supporters: {
        type: Array,
        default: ()=>{ return []; }
      },
      specialNetworkColor: {
        type: String,
        default: ""
      },
      sliderWidgets: {
        type: Array,
        default: ()=>{ return []; }
      },
      stories: {
        type: Array,
        default: ()=>{}
      },
      news: {
        type: Array,
        default: ()=>{}
      },
      sponsors: {
        type: Array,
        default: ()=>{}
      },
      bigCall: {
        type: Object,
        default: ()=>{}
      },
      imagesWidget: {
        type: Array,
        default: ()=>{}
      },
      sections: {
        type: Array,
        default: ()=>{}
      },
      sectionsTitle: {
        type: String,
        default: ""
      },
      bigBtn: {
        type: Object,
        default: ()=>{}
      },
      storiesTitle: {
        type: String,
        default: ""
      },
      newsTitle: {
        type: String,
        default: ""
      },
      topText: {
        type: Object,
        default: ()=>{}
      },
      topWysiwyg: {
        type: Object,
        default: ()=>{}
      },
      bottomText: {
        type: Object,
        default: ()=>{}
      },
      networkDescription: {
        type: Object,
        default: ()=>{}
      }
    },
    methods: {
      imgClasses(s){
        let ar = []
        if(s.mobile_visibility === 'False'){
          ar.push('d-none')
        }else if(s.mobile_visibility === 'True'){
          ar.push('d-inline-block')
        }
        if(s.desktop_visibility === 'False'){
          ar.push('d-md-none')
        }else if(s.desktop_visibility === 'True'){
          ar.push('d-md-inline-block')
        }

        return ar
      }
    },
    computed: {
      randomSliderWidgets(){
        let random = Math.floor(Math.random() * this.sliderWidgets.length),
            ar = [this.sliderWidgets[random]];
        console.log(random)
        return ar
      },
      mainSupporters(){
        return this.sponsors.filter(s => s.type==="0" )
      },
      owners(){
        return this.sponsors.filter(s => s.type==="1" )
      },
      collaborators(){
        return this.sponsors.filter(s => s.type==="2" )
      },
      supporterPartners(){
        return this.sponsors.filter(s => s.type==="3" )
      },
      artDirection(){
        return this.sponsors.filter(s => s.type==="4" )
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';
  @import '~@less/homepage';
</style>
